import apiClient from './apiClient';



// ==================== VEHICLE APIs ====================



export const addVehicle = async (vehicleData) => {
  const isFormData = typeof FormData !== 'undefined' && vehicleData instanceof FormData;
  const config = isFormData ? { headers: { 'Content-Type': undefined } } : {};
  const response = await apiClient.post('/vehicle/add', vehicleData, config);
  return response.data;
};

export const getAllVehicles = async (page = 1, limit = 1000, search = "") => {
  let url = `/vehicle/getall?page=${page}&limit=${limit}`;
  if (search) {
    url += `&search=${encodeURIComponent(search)}`;
  }
  const response = await apiClient.get(url);
  return response.data;
};

export const getVehicleById = async (id) => {
  const response = await apiClient.get(`/vehicle/get/${id}`);
  return response.data;
};

export const updateVehicle = async (id, vehicleData) => {
  const isFormData = typeof FormData !== 'undefined' && vehicleData instanceof FormData;
  const config = isFormData ? { headers: { 'Content-Type': undefined } } : {};
  const response = await apiClient.put(`/vehicle/update/${id}`, vehicleData, config);
  return response.data;
};



export const deleteVehicle = async (id) => {

  const response = await apiClient.delete(`/vehicle/delete/${id}`);

  return response.data;

};



export const getVehiclesByClientId = async (clientId) => {

  const response = await apiClient.get(`/vehicle/client/${clientId}`);

  return response.data;

};



export const assignVehicleToClient = async (clientId, vehicleId) => {

  const response = await apiClient.post('/client-vehicle-allot/add', {

    clientId,

    vehicleId

  });

  return response.data;

};



export const getAllVehicleClientAssignments = async (page = 1, limit = 100) => {

  const response = await apiClient.get(`/client-vehicle-allot/getall?page=${page}&limit=${limit}`);

  return response.data;

};



export const updateVehicleClientAssignment = async (allotmentId, clientId, vehicleId) => {

  const response = await apiClient.put(`/client-vehicle-allot/update/${allotmentId}`, {

    clientId,

    vehicleId

  });

  return response.data;

};



export const deleteVehicleClientAssignment = async (allotmentId) => {

  const response = await apiClient.delete(`/client-vehicle-allot/delete/${allotmentId}`);

  return response.data;

};



export const uploadVehicleSheet = async (file) => {

  const formData = new FormData();

  formData.append('file', file);



  const response = await apiClient.post('/vehicle/upload-sheet', formData, {

    headers: {

      'Content-Type': undefined

    }

  });

  return response.data;

};



export const getVehicleTravelStats = async (vehicleId, month = null, year = null, startDate = null, endDate = null) => {
  let url = `/vehicle/travel-stats/${vehicleId}`;
  const params = [];
  
  if (startDate && endDate) {
    params.push(`startDate=${startDate}`);
    params.push(`endDate=${endDate}`);
  } else {
    if (month !== null) params.push(`month=${month + 1}`); // +1 because months are 0-indexed in JS
    if (year !== null) params.push(`year=${year}`);
  }
  
  if (params.length > 0) {
    url += `?${params.join('&')}`;
  }
  
  const response = await apiClient.get(url);
  return response.data;
};

export const getVehicleTrips = async (vehicleId, month = null, year = null, page = 1, limit = 100) => {
  let url = `/vehicle/trips/${vehicleId}`;
  const params = [];
  
  if (month !== null) params.push(`month=${month + 1}`); // +1 because months are 0-indexed in JS
  if (year !== null) params.push(`year=${year}`);
  params.push(`page=${page}`);
  params.push(`limit=${limit}`);
  
  if (params.length > 0) {
    url += `?${params.join('&')}`;
  }
  
  
  const response = await apiClient.get(url);
  return response.data;
};

export const getAccountDetails = async (vehicleId) => {
  // Fetch account details by vehicle ID
  const response = await apiClient.get(`/account-details/by-vehicle/${vehicleId}`);
  return response.data;
};

export const createAccountDetails = async (accountDetails) => {
  const response = await apiClient.post('/account-details/add', accountDetails);
  return response.data;
};

export const updateAccountDetails = async (id, accountDetails) => {
  const response = await apiClient.put(`/account-details/update/${id}`, accountDetails);
  return response.data;
};

// Save (create or update) bank details by vehicle ID — single endpoint
export const saveAccountDetailsByVehicle = async (vehicleId, accountDetails) => {
  const response = await apiClient.put(`/account-details/by-vehicle/${vehicleId}`, accountDetails);
  return response.data;
};

export const getVehicleHistory = async (vehicleId) => {
  const response = await apiClient.get(`/client-vehicle-allot/vehicle-history/${vehicleId}`);
  return response.data;
};

const vehicalsManagementApi = {

  addVehicle,

  getAllVehicles,

  getVehicleById,

  getVehiclesByClientId,

  updateVehicle,

  deleteVehicle,

  assignVehicleToClient,

  getAllVehicleClientAssignments,

  updateVehicleClientAssignment,

  deleteVehicleClientAssignment,

  uploadVehicleSheet,

  getVehicleTravelStats,

  getVehicleTrips,

  getAccountDetails,

  createAccountDetails,

  updateAccountDetails,

  saveAccountDetailsByVehicle,

  getVehicleHistory

};

export default vehicalsManagementApi;

